import React from 'react';
import PropTypes from 'prop-types';

export default function Back(props) {
    const { className } = props;
    return (
        <svg className={className} fill="#01B6F5" width="12px" height="10px" viewBox="0 0 12 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g transform="translate(-30.000000, -32.000000)">
                <g transform="translate(30.000000, 18.000000)">
                    <g transform="translate(6.000000, 19.000000) rotate(-180.000000) translate(-6.000000, -19.000000) translate(0.000000, 14.000000)">
                        <path d="M0.350364964,5.78740157 L8.65901981,5.78740157 C8.88425443,5.78740157 8.98435871,6.07611549 8.83420229,6.2335958 L6.43169969,8.75328084 C6.28154327,8.91076115 6.28154327,9.14698163 6.43169969,9.30446194 L6.9822732,9.88188976 C7.13242961,10.0393701 7.35766423,10.0393701 7.50782065,9.88188976 L11.8873827,5.26246719 C12.0375391,5.10498688 12.0375391,4.8687664 11.8873827,4.71128609 L7.50782065,0.118110236 C7.35766423,-0.0393700787 7.13242961,-0.0393700787 6.9822732,0.118110236 L6.45672576,0.669291339 C6.30656934,0.826771654 6.30656934,1.06299213 6.45672576,1.22047244 L8.85922836,3.74015748 C9.00938478,3.92388451 8.9092805,4.21259843 8.68404588,4.21259843 L0.375391032,4.21259843 C0.175182482,4.21259843 0,4.37007874 0,4.58005249 L0,5.36745407 C0,5.57742782 0.150156413,5.78740157 0.350364964,5.78740157 Z" />
                    </g>
                </g>
            </g>
        </svg>
    );
}

Back.propTypes = {
    className: PropTypes.string,
};

Back.defaultProps = {
    className: undefined,
};
